import React, { useState, useEffect } from 'react';
import './CommonQuestions.css';

// SVG components
const PlusIcon = () => (
  <svg 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="#51C4E3" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);

const MinusIcon = () => (
  <svg 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="#51C4E3" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);

function CommonQuestions() {
  const [faqs, setFaqs] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await fetch('/api/faqs');
        if (!response.ok) throw new Error('Failed to fetch FAQs');
        const data = await response.json();
        setFaqs(data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchFaqs();
  }, []);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const renderAnswer = (text) => {
    if (!text.includes('<link')) return text;

    const parts = [];
    let currentIndex = 0;
    const linkRegex = /<link url="([^"]+)">([^<]+)<\/link>/g;
    let match;

    while ((match = linkRegex.exec(text)) !== null) {
      // Add text before the link
      if (match.index > currentIndex) {
        parts.push(text.slice(currentIndex, match.index));
      }

      // Add the link component
      const [fullMatch, url, linkText] = match;
      // Check if the URL is external (starts with http:// or https:// or //)
      const isExternal = /^(https?:)?\/\//.test(url);
      
      parts.push(
        <a 
          key={`link-${match.index}`} 
          href={url} 
          className="textLink"
          {...(isExternal ? {
            target: "_blank",
            rel: "noopener noreferrer"
          } : {})}
        >
          {linkText}
        </a>
      );

      currentIndex = match.index + fullMatch.length;
    }

    // Add any remaining text after the last link
    if (currentIndex < text.length) {
      parts.push(text.slice(currentIndex));
    }

    return parts;
  };

  if (loading) return <div className='is-flex is-flex-direction-rows is-justify-content-center'>Loading...</div>;
  if (error) return <div className='is-flex is-flex-direction-rows is-justify-content-center'>Error: {error}</div>;

  return (
    <div className="faq-container border1">
      {faqs.map((faq, index) => (
        <div key={index} className="faq-item">
          <div 
            className="faq-question"
            onClick={() => toggleFaq(index)}
          >
            <span>{faq.question}</span>
            <span className="faq-icon">
              {activeIndex === index ? <MinusIcon /> : <PlusIcon />}
            </span>
          </div>
          <div className={`faq-answer ${activeIndex === index ? 'active' : ''}`}>
            {faq.answer.map((paragraph, pIndex) => (
              <p key={pIndex}>{renderAnswer(paragraph)}</p>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default CommonQuestions;